import { mergeAllOfSchemas as e } from "./merge-all-of-schemas.js";
import { resolve as t } from "@scalar/workspace-store/resolve";
//#region src/schema/helpers/partition-all-of-compositions.ts
var n = ["oneOf", "anyOf"], r = (e, i, a) => {
	let { allOf: o, oneOf: s, anyOf: c, not: l, if: u, then: d, else: f, ...p } = e;
	Object.keys(p).length > 0 && i.push({
		kind: "object",
		schema: p
	});
	for (let e of n) {
		let t = e === "oneOf" ? s : c, n = Array.isArray(t) && t.some((e) => {
			let t = e && typeof e == "object" && "$ref" in e ? e.$ref : void 0;
			return typeof t == "string" && a.has(t);
		});
		Array.isArray(t) && t.length > 0 && i.push({
			kind: "choice",
			composition: e,
			value: { [e]: t },
			inheritedSelection: n
		});
	}
	if (Array.isArray(o)) {
		for (let e of o) if (e && typeof e == "object") {
			let n = t.schema(e), o = n.$ref;
			if (typeof o == "string") {
				if (a.has(o)) continue;
				r(n, i, new Set(a).add(o));
			} else r(n, i, a);
		}
	}
}, i = (n) => {
	if (!n) return { segments: [] };
	let { allOf: i, oneOf: a, anyOf: o, not: s, if: c, then: l, else: u, ...d } = n;
	if (!Array.isArray(i)) return { segments: [{
		kind: "object",
		schema: n
	}] };
	let f = [];
	Object.keys(d).length > 0 && f.push({
		kind: "object",
		schema: d
	});
	let p = "$ref" in n ? n.$ref : void 0, m = new Set(typeof p == "string" ? [p] : []);
	for (let e of i) if (e && typeof e == "object") {
		let n = t.schema(e), i = n.$ref;
		r(n, f, typeof i == "string" ? new Set(m).add(i) : m);
	}
	let h = [], g = [], _ = 0, v = () => {
		if (g.length === 0) return;
		let t = g.length === 1 ? g[0] : e({ allOf: g });
		h.push({
			kind: "object",
			schema: t
		}), g = [];
	};
	for (let e of f) e.kind === "object" ? g.push(e.schema) : e.inheritedSelection ? _++ : (v(), h.push({
		kind: "choice",
		composition: e.composition,
		value: e.value,
		choiceIndex: _++
	}));
	return v(), { segments: h };
};
//#endregion
export { i as partitionAllOfCompositions };

//# sourceMappingURL=partition-all-of-compositions.js.map